import React from 'react';
import { Box, Flex, Text, Icon, Button } from '@chakra-ui/react';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';

/**
 * Banner post-save inline (no un modal separado, se pega arriba del grid de
 * cards). Muestra "N de M pagos vinculados correctamente" y da botón para
 * reintentar solo los fallidos.
 */
export default function PostSaveSummary({ savedCount, failedCount, onRetryFailed }) {
  const total = savedCount + failedCount;
  const allOk = failedCount === 0;
  const bg = allOk ? '#F0FDF4' : '#FFFBEB';
  const border = allOk ? '#C6F6D5' : '#FCD34D';
  const color = allOk ? '#22543D' : '#92400E';
  const IconEl = allOk ? FiCheckCircle : FiAlertCircle;

  return (
    <Box bg={bg} borderWidth="1px" borderColor={border} borderRadius="8px" p={3} mb={4}>
      <Flex align="center" gap={3}>
        <Icon as={IconEl} color={color} boxSize="20px" />
        <Box flex="1">
          <Text fontSize="13px" fontWeight="700" color={color}>
            {savedCount} de {total} pagos vinculados correctamente
          </Text>
          {!allOk && (
            <Text fontSize="12px" color={color} opacity={0.85}>
              {failedCount} pago{failedCount === 1 ? '' : 's'} necesita{failedCount === 1 ? '' : 'n'}{' '}
              ajustes. Otra sesión pudo haber tomado alguna materia; revisa el
              detalle en cada tarjeta y vuelve a intentar.
            </Text>
          )}
        </Box>
        {!allOk && (
          <Button
            size="sm"
            variant="outline"
            colorScheme="orange"
            onClick={onRetryFailed}
          >
            Reintentar fallidos
          </Button>
        )}
      </Flex>
    </Box>
  );
}
